import { render, staticRenderFns } from "./CartLinesDesktop.vue?vue&type=template&id=986d96ae&scoped=true"
import script from "./CartLinesDesktop.vue?vue&type=script&lang=js"
export * from "./CartLinesDesktop.vue?vue&type=script&lang=js"
import style0 from "./CartLinesDesktop.vue?vue&type=style&index=0&id=986d96ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986d96ae",
  null
  
)

export default component.exports